import errorImage from "../assets/images/pagenotfound.webp";
import TopNavbar from './TopNavbar';
import Footer from './Footer';

export default function NotFound() {
    return (
        <>
        <TopNavbar/>
            <div style={{backgroundColor: 'black', height: '100vh', marginBottom: '-50px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                <img src={errorImage} alt="" className="pageNotFoundImg"/>
                <a href="/"><button className="btn btn-lg btn-primary">Go to Homepage</button></a>
            </div>
        <Footer/>
        </>
    )
}